{
  "payments": "Pagos",
  "years-range-title": "Años",
  "years-range": "Rangos de años",
  "principalInterest": "Principal e Intereses",
  "interestOnly?": "¿Sólo interés?",
  "interestOnly": "Sólo interés",
  "no": "No",
  "mortgageInsurance": "Seguro Hipotecario",
  "estimatedEscrow": "Fideicomiso estimado",
  "amount": "Monto",
  "range": "Rango",
  "estimated-taxes-title": "Impuestos, seguros y evaluaciones estimatadas",
  "per-month": "Por mes",
  "per-week": "Por semana",
  "includes": "Incluye",
  "inEscrow": "En fideicomiso",
  "propertiesTaxes": "Impuestos de la propiedad",
  "homeownersInsurance": "Seguro del propietario",
  "other": "Otro",
  "addADescription": "Agregar una descripción...",
  "min": "Min",
  "max": "Max",
  "invalidNumber": "Número inválido",
  "minGreaterThanMax": "El mínimo no puede ser mayor que el máximo",
  "invalidInteger": "Número debe ser entero",
  "requiredField": "Campo requerido",
  "formChanged": "Estos cambios afectan la orden y deben de revisarse completamente",
  "escrowInfoMessage": "La información aquí depende de los interruptores de arriba",
  "mortgage-insurance": "Seguro Hipotecario",
  "calculated-value-is": "El valor calculado es:",
  "calculated-value-modified": "El valor calculado fue modificado"
}
